import React from "react";
import PropTypes from "prop-types";
import StaticCardActionBtn from "../../../../components/StaticCardActionBtn";
import { observer } from "mobx-react-lite";
import "./style.scss";

export default observer(function SwiperIndicate({
  isToRight,
  isToLeft,
  isNegative,
  isPositive,
  isNeutral,
  isToTop,
}) {
  SwiperIndicate.propTypes = {
    isToRight: PropTypes.bool,
    isToLeft: PropTypes.bool,
    isNegative: PropTypes.bool,
    isPositive: PropTypes.bool,
    isNeutral: PropTypes.bool,
    isToTop: PropTypes.bool,
  };
  return (
    <>
      {(isToLeft || isNegative) && (
        <div className="in-game-page__main__swipe-card__wrapper__center-indicate">
          <StaticCardActionBtn type="negative" />
        </div>
      )}
      {(isToRight || isPositive) && (
        <div className="in-game-page__main__swipe-card__wrapper__center-indicate">
          <StaticCardActionBtn type="positive" />
        </div>
      )}
      {(isToTop || isNeutral) && (
        <div className="in-game-page__main__swipe-card__wrapper__center-indicate">
          <StaticCardActionBtn type="neutral" />
        </div>
      )}
    </>
  );
});
